import { isServerSide } from "@jti/fe-common";

export const isRestrictedSlug = (slugs: string[] | undefined): boolean => {
  if (isServerSide()) return false;

  const url = new URL(document.location.href).pathname;
  const slug = url.split("/").pop();
  if (!slugs?.length || !slug) return false;

  return slugs.some((restrictedSlug) => slug.includes(restrictedSlug));
};
